import { RESET_PASSWORD, RESET_PASSWORD_FAILURE } from "./actionTypes"

const initialState = {
  errorMessage: null,
  reset: null,
}

const ResetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        ...state,
      }

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        errorMessage: action.payload,
      }

    case "RESET_ERROR_MESSAGE":
      return {
        ...state,
        errorMessage: null,
      }

    case "RESET_DOWN_MESSAGE":
      return {
        ...state,
        reset: null,
      }

    case "RESET_UP_MESSAGE":
      return {
        ...state,
        reset: true,
      }

    default:
      return state
  }
}

export default ResetPassword
